import SubstrateSearchRequest from '../../../data/schema/SubstrateSearchRequest';
import { SearchResultConversation } from '../../../data/schema/SubstrateSearchResponse';
import ConversationType from 'owa-service/lib/contract/ConversationType';
import {
    convertRecipientToSingleRecipientType,
    convertSearchSortOrder,
    convertToFolderId,
    convertToItemId,
    convertToItemIds,
    convertUtcDateTimeToRequestTimeZone,
} from './converterHelpers';

export default function convertSearchResultConversationToConversationType(
    searchConversation: SearchResultConversation,
    request: SubstrateSearchRequest
): ConversationType {
    return {
        Categories: searchConversation.Categories,
        ConversationId: convertToItemId(searchConversation.ConversationId),
        ConversationTopic: searchConversation.ConversationTopic,
        FlagStatus: searchConversation.FlagStatus,
        FolderId: convertToFolderId(searchConversation.ParentFolderId),
        FolderRefinerId: searchConversation.FolderRefinerId,
        From: convertRecipientToSingleRecipientType(searchConversation.From),
        GlobalItemIds: convertToItemIds(searchConversation.GlobalItemIds),
        GlobalMessageCount: searchConversation.GlobalMessageCount,
        GlobalUnreadCount: searchConversation.GlobalUnreadCount,
        HasAttachments: searchConversation.HasAttachments,
        Hashtags: searchConversation.Hashtags,
        HasIrm: searchConversation.HasIrm,
        Importance: searchConversation.Importance,
        ItemClasses: searchConversation.ItemClasses,
        ItemIds: convertToItemIds(searchConversation.ItemIds),
        LastDeliveryOrRenewTime: convertUtcDateTimeToRequestTimeZone(
            searchConversation.LastDeliveryOrRenewTime,
            request
        ),
        LastDeliveryTime: convertUtcDateTimeToRequestTimeZone(
            searchConversation.LastDeliveryTime,
            request
        ),
        LastModifiedTime: convertUtcDateTimeToRequestTimeZone(
            searchConversation.LastModifiedTime,
            request
        ),
        MailboxGuids: searchConversation.MailboxGuids,
        MessageCount: searchConversation.MessageCount,
        ParentFolderId: convertToFolderId(searchConversation.ParentFolderId),
        Preview: searchConversation.Preview,
        SenderSMTPAddress: searchConversation.SenderSMTPAddress,
        SortOrderSource: convertSearchSortOrder(searchConversation.SortOrderSource),
        UniqueRecipients: searchConversation.UniqueRecipients,
        UniqueSenders: searchConversation.UniqueSenders,
        UnreadCount: searchConversation.UnreadCount,
    };
}
